var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { Resource } from 'react-admin';
import ListGuesser from './ListGuesser';
import CreateGuesser from './CreateGuesser';
import EditGuesser from './EditGuesser';
import ShowGuesser from './ShowGuesser';
const ResourceGuesser = (_a) => {
    var { list, edit, create, show } = _a, props = __rest(_a, ["list", "edit", "create", "show"]);
    return (React.createElement(Resource, Object.assign({}, props, { create: undefined === create ? CreateGuesser : create, edit: undefined === edit ? EditGuesser : edit, list: undefined === list ? ListGuesser : list, show: undefined === show ? ShowGuesser : show })));
};
ResourceGuesser.propTypes = {
    name: PropTypes.string.isRequired,
};
export default ResourceGuesser;
//# sourceMappingURL=ResourceGuesser.js.map